<template>
  <vue-modal @close="closeModal">
    <template v-slot:header>
      <h3>Создание нового лида</h3>
    </template>

    <template v-slot:body>
      <div class="input_group">
        <div class="input_block">
          <label class="typo__label" :class="{ 'error-input' : formErrors.has('city') }">Город</label>
          <multiselect
            v-model="lidData.city"

            :options="citySelectorOptions"
            :clear-on-select="false"
            :preserve-search="true"
            :show-labels="false"

            @input="validateForm"

            label="value"
            placeholder="Выбрать"
            track-by="value"
          >
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.value }}</span>
              </div>
            </template>
          </multiselect>

        </div>

        <div class="input_block">
          <label for="lid-data-phone" :class="{ 'error-input' : formErrors.has('phone') }">Телефон</label>
          <input id="lid-data-phone" type="tel" v-mask="'+7##########'" v-model="lidData.phone" @input="validateForm">
        </div>

        <div class="input_block">
          <label class="typo__label" :class="{ 'error-input' : formErrors.has('tow') }">Вид работ</label>
          <multiselect
            v-model="lidData.tow"

            :options="filteredTowsOptions"
            :clear-on-select="false"
            :preserve-search="true"
            :show-labels="false"

            @input="validateForm"

            label="tow"
            placeholder="Выбрать"
            track-by="id"
          >
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.tow }}</span>
              </div>
            </template>
          </multiselect>
        </div>

        <div class="input_block">
          <label class="typo__label" :class="{ 'error-input' : formErrors.has('status') }">Статус</label>
          <multiselect
            v-model="lidData.status"

            :options="statusSelectorOptions"
            :clear-on-select="false"
            :preserve-search="true"
            :show-labels="false"

            @input="validateForm"

            label="label"
            placeholder="Выбрать"
            track-by="code"
            class="status-selector"
          >
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.label }}</span>
              </div>
            </template>
          </multiselect>
        </div>

        <div class="input_block input_block--full">
          <label for="lid-data-order-text">Текст заявки</label>
          <textarea id="lid-data-order-text" v-model="lidData.info"></textarea>
        </div>

        <div class="input_block input_block--full">
          <label for="lid-data-moderator-comment">Комментарий модератора</label>
          <textarea id="lid-data-moderator-comment" v-model="lidData.comm_moderator"></textarea>
        </div>

      </div>
    </template>

    <template v-slot:footer>
      <button @click="addLid" :disabled="formErrors.size > 0" type="button" class="btn btn-success submit-btn">Добавить</button>
      <p v-if="formErrors.has('emptyFields')" class="error-required">Заполните все поля</p>
    </template>
  </vue-modal>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask'
import vueModal from "@/components/modal/vueModal.vue";
import Multiselect from 'vue-multiselect';
import statusOptionList from '@/data/table/statusColumn'
import axiosInstance from "@/services/api.js"

export default {
  name: 'create-lid-modal',
  components: {
    vueModal,
    Multiselect,
  },

  directives: {
    mask
  },

  data () {
    return {
      lidData: {
        city: {},
        date: '',
        phone: '',
        tow: {},
        status: {},
        site: 'Введено модератором',
        info: '',
        comm_moderator: '',

        // default options for backend
        source: '',
        partner_id: '',
      },

      statusSelectorOptions: this.getfilteredStatusOptions(statusOptionList),
      formErrors: new Set(),
    }
  },

  computed: {
    ...mapGetters([
      'Tows',
      'citySelectorOptions',
    ]),

    filteredTowsOptions () {
      return this.Tows.filter((option) => option.id !== 1);
    },
  },

  beforeMount() {
    this.validateForm();
  },

  methods: {
    closeModal () {
      this.$emit('close');
    },

    async addLid () {

      this.lidData.date = (new Date(Date.now() + this.$tzoffset)).toISOString().slice(0, 19);

      axiosInstance.put('/orders', this.getCorrectLidData())
      .then(() => {
        Vue.alert("Новый лид добавлен", "Success", "success", {
          reverseButtons: true
        });
      })
      .catch((err) => {
        Vue.alert(JSON.stringify(err.response.data), "Error", "error", {
          reverseButtons: true
        })
      })
      .finally(() => {
        this.closeModal();
      });

    },

    getCorrectLidData () {
      const resultLidData = JSON.parse(JSON.stringify(this.lidData));

      resultLidData.city = this.lidData.city.value;
      resultLidData.status = this.lidData.status.code;
      resultLidData.tow = this.lidData.tow.id;

      return resultLidData;
    },

    validateForm () {
      const lidDataRequired = [
        'phone',
        'city',
        'tow',
        'status',
      ]

      this.formErrors.clear();

      // Check required fields
      for (let i = 0; i < lidDataRequired.length; i++) {
        const field = this.lidData[lidDataRequired[i]];

        if (!field) {
          this.formErrors.add('emptyFields');
          this.formErrors.add(lidDataRequired[i]);

          continue;
        }

        if (typeof field === 'object') {

          if (!Object.keys(field).length) {
            this.formErrors.add('emptyFields');
            this.formErrors.add(lidDataRequired[i]);
          }

        } else if (!field.length) {
          this.formErrors.add('emptyFields');
          this.formErrors.add(lidDataRequired[i]);
        }

      }

      if (!this.formErrors.has('phone') && this.lidData.phone.length !== 12) {
        this.formErrors.add('phone');
      }

      // If default status value
      if (!this.formErrors.has('status') && this.lidData.status.code === 0) {
        this.formErrors.add('status');
      }

      // If default tow value
      if (!this.formErrors.has('tow') && this.lidData.tow.id === 1) {
        this.formErrors.add('tow');
      }
    },

    getfilteredStatusOptions (options) {
      return options.filter((option) => option.code !== 0);
    }
  }
}
</script>

<style scoped>
  .input_group {
    width: 100%;

    display: flex;
    flex-wrap: wrap;

    margin: -7.5px -5px;
  }

  .input_group .input_block {
    flex: 1 1 240px;

    margin: 7.5px 5px;
  }

  .input_group .input_block--full {
    flex-basis: 100%;
  }

  .submit-btn {
    width: 100%;
    max-width: 240px;

    padding: 0.7em 1.5em;

    margin: 0 auto;
    float: unset;
  }

  .input_block > input,
  .input_block > textarea {
    min-height: 43px;
    width: 100%;

    padding: 8px;

    color: inherit;

    border: 1px solid #eaeaea;
    border-radius: 5px;
    border: 1px solid #e8e8e8;

    transition: .3s ease;
  }

  .input_block > input:hover,
  .input_block > input:focus,
  .input_block > textarea:hover,
  .input_block > textarea:focus {
    outline: 0;
    border-color: #68e7ac;
  }

  .input_block > label {
    margin-bottom: 0.5em;
  }

  .error-input {
    color: #e03a3a;
  }

  .error-required {
    width: 100%;

    display: block;
    margin: 0.8em 0;

    text-align: center;
    color: #e03a3a;
  }

</style>

<style>
  .status-selector .multiselect__element {
    color: #fff;
  }

  .status-selector .multiselect__element {
    background: #e04f4f;
  }

  .status-selector .multiselect__element:first-child {
    background: #41ba69;
  }
</style>
